import ChangeEpisodicItem from '../change-episodic-items/change-episodic-item.entity';
import ChangeScene from '../change-scenes/change-scene.entity';
import Change from '../changes/change.entity';
import CmChangePicture from '../cm-change-pictures/cm-change-picture.entity';
import CmWrapBox from '../cm-wrap-boxes/cm-wrap-box.entity';
import { DEPARTMENTS } from '../enums/enums';
import HaChangeScene from '../ha-change-scenes/ha-change-scene.entity';
import HaChange from '../ha-changes/ha-change.entity';
import HaLookPicture from '../ha-look-pictures/ha-look-picture.entity';
import MuChangeScene from '../mu-change-scenes/mu-change-scene.entity';
import MuChange from '../mu-changes/mu-change.entity';
import MuLookPicture from '../mu-look-pictures/mu-look-picture.entity';
import {
	SosCreateResponse,
	SosDeleteResponse,
	SosGetResponse,
	SosUpdateResponse,
} from '../sos-response';
import { ProdBaseESDoc } from '../types';

export interface ChangeLookESDoc extends ProdBaseESDoc {
	change_num: string;
	char_first_name: string;
	char_last_name: string;
	char_id: number;
	description: string;
	episode_num: string;
	char_num: string;
}

export interface DeptSpecificChangeLookCreateResponse<T extends DEPARTMENTS>
	extends SosCreateResponse {
	created: T extends DEPARTMENTS.CM
		? {
				Change: Change[];
		  }
		: T extends DEPARTMENTS.HA
		? {
				HaChange: HaChange[];
		  }
		: T extends DEPARTMENTS.MU
		? {
				MuChange: MuChange[];
		  }
		: never;
}

export type ChangeLookCreateResponse =
	| DeptSpecificChangeLookCreateResponse<DEPARTMENTS.CM>
	| DeptSpecificChangeLookCreateResponse<DEPARTMENTS.HA>
	| DeptSpecificChangeLookCreateResponse<DEPARTMENTS.MU>;

export interface DeptSpecificChangeLookGetResponse<T extends DEPARTMENTS>
	extends SosGetResponse {
	listed: T extends DEPARTMENTS.CM
		? {
				Change: Change[];
				ChangeEpisodicItem?: ChangeEpisodicItem[];
				CmChangePicture?: CmChangePicture[];
				CmWrapBox?: CmWrapBox[];
		  }
		: T extends DEPARTMENTS.HA
		? {
				HaChange: HaChange[];
				HaLookPicture?: HaLookPicture[];
		  }
		: T extends DEPARTMENTS.MU
		? {
				MuChange: MuChange[];
				MuLookPicture?: MuLookPicture[];
		  }
		: never;
	next?: number;
	previous?: number;
}

export type ChangeLookGetResponse =
	| DeptSpecificChangeLookGetResponse<DEPARTMENTS.CM>
	| DeptSpecificChangeLookGetResponse<DEPARTMENTS.HA>
	| DeptSpecificChangeLookGetResponse<DEPARTMENTS.MU>;

export interface DeptSpecificChangeLookDeleteResponse<T extends DEPARTMENTS>
	extends SosDeleteResponse {
	destroyed: T extends DEPARTMENTS.CM
		? {
				Change: Change[];
				ChangeScene: ChangeScene[];
				CmChangePicture: CmChangePicture[];
				ChangeEpisodicItem: ChangeEpisodicItem[];
		  }
		: T extends DEPARTMENTS.HA
		? {
				HaChange: HaChange[];
				HaChangeScene: HaChangeScene[];
				HaLookPicture: HaLookPicture[];
		  }
		: T extends DEPARTMENTS.MU
		? {
				MuChange: MuChange[];
				MuChangeScene: MuChangeScene[];
				MuLookPicture: MuLookPicture[];
		  }
		: never;
}

export type ChangeLookDeleteResponse =
	| DeptSpecificChangeLookDeleteResponse<DEPARTMENTS.CM>
	| DeptSpecificChangeLookDeleteResponse<DEPARTMENTS.HA>
	| DeptSpecificChangeLookDeleteResponse<DEPARTMENTS.MU>;

export interface DeptSpecificChangeLookUpdateResponse<T extends DEPARTMENTS>
	extends SosUpdateResponse {
	updated: T extends DEPARTMENTS.CM
		? {
				Change: Change[];
		  }
		: T extends DEPARTMENTS.HA
		? {
				HaChange: HaChange[];
		  }
		: T extends DEPARTMENTS.MU
		? {
				MuChange: MuChange[];
		  }
		: never;
}

export type ChangeLookUpdateResponse =
	| DeptSpecificChangeLookUpdateResponse<DEPARTMENTS.CM>
	| DeptSpecificChangeLookUpdateResponse<DEPARTMENTS.HA>
	| DeptSpecificChangeLookUpdateResponse<DEPARTMENTS.MU>;
